import { config } from "../app/base/constant";
import axios from "axios";
import { Cookie, util } from "../app/base/utils";
import { API_ROUTE_CONTROLLER } from "../app/base/routes";

export class MarketingServices {
  /**
   * we are using node API to call current marketing services hubspot
   */
  public static async post(
    _body: any,
    // endPoint: string,
    _action: string,
    _id: number,
    _method: string = ""
  ) {
    let _url = "https://api.hubapi.com/crm/v3/objects/" + _action + "/" + _id;
    let method = "PATCH";
    if (method != "") _method = method;

    if (_action == "associations") {
      _method = "PUT";
      _url =
        "https://api.hubapi.com/crm-associations/v1/" + _action + "/" + _id;
    } else if (_action == "companies") {
      
      _url = "https://api.hubapi.com/crm/v3/objects/companies/" + _id;
    } else {
      if (_action == "delete") {
        _method = "DELETE";
        _url = "https://api.hubapi.com/contacts/v1/contact/vid/" + _id;
      } else {
      }
    }
    try {
      const data = {
        method: "POST",
        header: {
          "accept": "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          method: _method,
          url: _url,
          properties: {
            properties: _body,
          },
        }),
        //
      };
      
      
      const url = API_ROUTE_CONTROLLER.hubspot_api
      const token: any = Cookie.get();
      const response = await fetch(
        url, data
      )
      
      const jsonResp = await response.json();
      
      if (jsonResp != null) {
        return jsonResp;
      } else {
        return null;
      }
    } catch {
      return null;

    }
  }

  public static async create(
    _body: any,
  ) {
    let _url = "https://api.hubapi.com/crm/v3/objects/contacts"
    let _method = "POST";
    try {
      const data = {
        method: "POST",
        header: {
          "accept": "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify({
          method: _method,
          url: _url,
          properties: {
            properties: _body,
          },
        }),
        //
      };
      
      
      const url = API_ROUTE_CONTROLLER.hubspot_api
      const token: any = Cookie.get();
      const response = await fetch(
        url, data
      )
      
      const jsonResp = await response.json();
      
      if (jsonResp != null) {
        return jsonResp;
      } else {
        return null;
      }
    } catch {
      return null;

    }
  }

  public static bulkUploadAssociation(
    _body: any,
    endPoint: string,
    _action: string,
    _id: number,
    _method: string = ""
  ) {
    let _url = "https://api.hubapi.com/crm/v3/objects/" + _action + "/" + _id;
    let method = "PATCH";
    if (method != "") _method = method;

    if (_action == "associations") {
      _method = "PUT";
      _url =
        "https://api.hubapi.com/crm-associations/v1/" + _action + "/" + _id;
    } else if (_action == "companies") {
      _url = "https://api.hubapi.com/crm/v3/objects/companies/" + _id;
    } else {
      if (_action == "delete") {
        _url = "https://api.hubapi.com/contacts/v1/contact/vid/" + _id;
      } else {
      }
    }
    const data = {
      method: "POST",
      header: {
        accept: "application/json",
        "content-type": "application/json",
      },
      body: JSON.stringify({
        inputs: {
          properties: [_body],
        },
      }),
      //
    };
    //const url: any = config().API_SERVICE_URL;
    const token: any = Cookie.get();
    return axios
      .post(`${endPoint}`, data, {
        headers: {
          appId: config().APP_ID,
          appSecret: config().APP_SECRET,
          Authorization: token["accessToken"],
        },
      })
      .then((response: any) => {
        return response;
      })
      .catch(function (error) {
        
      });
  }
}
